import * as React from "react";
import { memo } from "react";

const SvgIron = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.61 11.205H.451a.39.39 0 0 1-.385-.324c-.15-.877-.046-1.987.293-3.128a10.642 10.642 0 0 1 1.898-3.598C3.68 2.387 6.346.235 10.983.016h4.699c.242-.011.455-.016.65-.016.968 0 1.504.132 1.848.456.353.332.424.786.514 1.36a18.036 18.036 0 0 0 .077.468l.826 5.713.394 2.737a.39.39 0 0 1-.382.471Zm-18.814-.78h18.363l-.335-2.316L18 2.403a16.82 16.82 0 0 1-.076-.465c-.073-.46-.12-.765-.278-.914-.177-.166-.594-.243-1.314-.243-.186 0-.39.005-.623.015H11.01c-4.34.207-6.824 2.206-8.143 3.848-1.617 2.01-2.19 4.322-2.07 5.78H.795Z"
      fill="#000"
    />
    <path
      d="M16.35 6.479 5.534 6.478a.39.39 0 0 1-.325-.606c.082-.124.173-.275.27-.435.368-.613.874-1.45 1.674-2.136.954-.818 2.129-1.237 3.493-1.247l5.174-.037h.003a.39.39 0 0 1 .387.336l.521 3.655a.39.39 0 0 1-.382.47ZM6.234 5.697H15.9L15.486 2.8l-4.833.034c-2.599.02-3.7 1.678-4.419 2.863ZM17.506 12.611H.747a.39.39 0 0 1-.382-.31L.07 10.895a.39.39 0 0 1 .382-.47h17.054a.39.39 0 0 1 .39.39v1.406a.39.39 0 0 1-.39.39Zm-16.442-.78h16.052v-.626H.933l.131.626Z"
      fill="#000"
    />
    <path
      d="M13.454 6.464H9.261a.39.39 0 0 1-.39-.39v-.696A1.15 1.15 0 0 1 10.02 4.23h2.677c.633 0 1.148.515 1.148 1.148v.696a.39.39 0 0 1-.39.39Zm-3.802-.78h3.413v-.306a.368.368 0 0 0-.367-.367H10.02a.368.368 0 0 0-.368.367v.305ZM15.542 8.22h-1.13a.39.39 0 1 1 0-.78h1.13a.39.39 0 1 1 0 .78ZM15.555 9.468h-1.128a.39.39 0 1 1 0-.78h1.128a.39.39 0 1 1 0 .78Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgIron);
export default Memo;
